// OverviewTab.tsx
import React from "react";
import {
  RevenueKPIs,
  DailyAnalytics,
  RevenueTransaction,
  ColorTheme,
} from "../types/revenue.types";
import { KPICard } from "../shared/KPICard";
import { SimpleLineChart } from "../charts/SimpleLineChart";
import { TransactionCard } from "../cards/TransactionCard";

interface OverviewTabProps {
  kpis: RevenueKPIs | null;
  dailyData: DailyAnalytics[];
  transactions: RevenueTransaction[];
  colorTheme: ColorTheme;
  userRole: string;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({
  kpis,
  dailyData,
  transactions,
  colorTheme,
  userRole,
}) => {
  if (!kpis) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {/* KPI Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <KPICard
          icon="💰"
          title="Total Revenue"
          value={kpis.current_period.total_revenue}
          subtitle={`${kpis.current_period.total_transactions} transactions`}
          colorTheme={colorTheme}
          trend={{
            value: kpis.growth_metrics.revenue_growth_percentage,
            isPositive: kpis.growth_metrics.revenue_growth_percentage > 0,
          }}
        />
        <KPICard
          icon="🏥"
          title="Clinic Revenue"
          value={kpis.current_period.clinic_revenue}
          colorTheme={colorTheme}
        />
        <KPICard
          icon="👨‍⚕️"
          title="Provider Revenue"
          value={kpis.current_period.provider_revenue}
          colorTheme={colorTheme}
        />
        <KPICard
          icon="❤️"
          title="Charity"
          value={kpis.current_period.charity_revenue}
          colorTheme={colorTheme}
        />
      </div>

      {/* Daily Revenue Chart */}
      <div
        style={{
          background: "white",
          padding: "24px",
          borderRadius: "12px",
          marginBottom: "24px",
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: colorTheme.gray900,
            marginBottom: "16px",
          }}
        >
          Daily Revenue Trend
        </h3>
        <SimpleLineChart
          data={dailyData}
          height={250}
          color={colorTheme.primary}
        />
      </div>

      {/* Recent Transactions */}
      <div
        style={{ background: "white", padding: "24px", borderRadius: "12px" }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: colorTheme.gray900,
            marginBottom: "16px",
          }}
        >
          Recent Transactions
        </h3>
        <div style={{ maxHeight: "600px", overflowY: "auto" }}>
          {transactions.slice(0, 10).map((transaction) => (
            <TransactionCard
              key={transaction.id}
              transaction={transaction}
              colorTheme={colorTheme}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
